'use client';

import clsx from 'clsx';
import { MdOutlineNotifications } from 'react-icons/md';

import { SecondaryButton } from '@web/ui';

import styles from './NotificationsButton.module.scss';

export function NotificationsButton({
  unreadCount,
  onClick,
  variant = 'mini',
}: {
  unreadCount: number;
  onClick: () => void;
  variant?: 'mini' | 'medium';
}) {
  const hasUnread = unreadCount > 0;
  const ariaLabel = hasUnread
    ? `Open notifications, ${unreadCount} unread`
    : 'Open notifications';

  return (
    <span
      className={clsx(
        styles.notificationsButton,
        variant === 'medium' && styles.notificationsButtonMedium,
      )}
    >
      <SecondaryButton
        ariaLabel={ariaLabel}
        variant={variant}
        onClick={onClick}
        backgroundOverride={hasUnread ? 'emphasis' : 'theme'}
      >
        <MdOutlineNotifications size={variant === 'medium' ? 'auto' : 18} />
      </SecondaryButton>
      {hasUnread ? (
        <span className={styles.notificationsButton__count} aria-hidden="true">
          {unreadCount > 9 ? '9+' : unreadCount}
        </span>
      ) : null}
    </span>
  );
}
